export type ConnectionStatus = 'ONLINE' | 'OFFLINE' | 'ONLINE_WITH_ISSUES';

export const StatusTypes = {
    ALL: 'ALL',
    OFFLINE: 'OFFLINE',
    ONLINE: 'ONLINE',
    ONLINE_WITH_ISSUES: 'ONLINE_WITH_ISSUES',
    UNKNOWN: null,

    friendlyString(entry: string | null) {
        if (entry === null) {
            return 'Unknown';
        }
        const map = {
            [this.ALL]: 'All',
            [this.OFFLINE]: 'Offline',
            [this.ONLINE]: 'Online',
            [this.ONLINE_WITH_ISSUES]: 'Online with Issues',
        };

        return map[entry] || entry;
    },
};

export const ConnectionStatusOptions = [
    {
        name: StatusTypes.friendlyString(StatusTypes.ONLINE),
        value: StatusTypes.ONLINE,
    },
    {
        name: StatusTypes.friendlyString(StatusTypes.OFFLINE),
        value: StatusTypes.OFFLINE,
    },
    {
        name: StatusTypes.friendlyString(StatusTypes.ONLINE_WITH_ISSUES),
        value: StatusTypes.ONLINE_WITH_ISSUES,
    },
] as const;

export const ReducedConnectionStatusOptions = ConnectionStatusOptions.filter(
    option => option.value !== StatusTypes.ONLINE_WITH_ISSUES,
);
